module.exports = {
  buildVersion: "4.0.3",
  buildDate: 1793743409091,
}